// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__NNEXZ","rootNoMargin":"styles_rootNoMargin__1vELE"};